/* eslint no-console: ["error", { allow: ["warn", "error", "log", "dir"] }] */
import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import useAxios from 'scripts/hooks/useAxios';
import { CartContext } from '../../Context/cart/CartContext';
import { useMsal, useAccount } from '@azure/msal-react';
import { LargeFormLoader } from '../../../components/ContentLoader';
import { alertLoadingError, confirmAlert } from '../../../components/Confirm';
import { useTranslation } from 'react-i18next';
import { convertToCountry } from 'scripts/components/Utils/market';
import { useGlobalState } from '../../../contexts/GlobalStateContext';

import StdDelivery from './stdDelivery';
import AltDelivery from './altDelivery';

export default function Checkout({ placeOrder, setFreight }) {
    const { cartItems } = useContext(CartContext);
    const { callApi } = useAxios();
    const { accounts } = useMsal();
    const [error, setError] = useState({ status: "ERROR", message: "Success" });
    const { globalState } = useGlobalState();
    const { t } = useTranslation();

    const account = useAccount(accounts[0] || {});
    const custNameArray = account.name?.split(" ") ?? [],
        custName = custNameArray[0] + " " + custNameArray[custNameArray.length - 1]?.charAt(0);

    const custNumber = globalState.activeUserCompany?.accountId ?? '';

    let initInputValues = {
        ShippingInstructions: '',
        GoodsMark: '',
        HeaderId: '',
        DeliveryNotificationPhone: '',
        CustomerPo: custName,
        ReferenceNo: custName
    },
        initReseller = {
            AddressType: 6,
            Name: '',
            Address1: '',
            City: '',
            PostalCode: '',
            Country: '',
        };

    let history = useHistory(),
        [inputs, setInputs] = useState(initInputValues),
        [reseller, setReseller] = useState(initReseller),
        [optionalAddress, setOptionalAddress] = useState(initReseller),
        [useOptionalAddress, setUseOptionalAddress] = useState(false),
        [deliveryAddressOptions, setDeliveryAddressOptions] = useState([]),
        [selectedAddressOptions, setSelectedAddressOptions] = useState(0),
        [requestedDate, setRequestedDate] = useState(new Date().toISOString().split('T')[0]),
        [promiseDate, setPromiseDate] = useState(''),
        [readyToSend, setReadyToSend] = useState(false),
        [errorMessage, setErrorMessage] = useState(''),
        [isLoading, setIsLoading] = useState(true),
        [onGoingMaintenance, setOnGoingMaintenance] = useState(false),
        [loadingATP, setLoadingATP] = useState(false);

    useEffect(() => {
        checkEmptyCart();
        const fetchData = async () => {
            try {
                /*const maintenanceCall = callApi({
                    method: 'get',
                    url: '/api/order/maintenanceStatus',
                }); */

                const contactInfoCall = callApi({
                    method: 'get',
                    url: '/api/reseller/contactInfo',
                    headers: {
                        'x-active-user-company': globalState.activeUserCompany?.contactId,
                    },
                });

                const deliveryAddressCall = await callApi({
                    method: 'get',
                    url: '/api/reseller/deliveryAddress',
                    headers: {
                        'x-active-user-company': globalState.activeUserCompany?.contactId,
                    },
                });

                const deliveryCall = callApi({
                    method: 'post',
                    url: '/api/order/deliveryDate',
                    data: {
                        cartItems,
                        requestedDate: requestedDate.replace(/-/g, ''),
                    },
                    headers: {
                        'x-active-user-company': globalState.activeUserCompany?.contactId,
                    },
                });

                Promise.all([deliveryAddressCall, contactInfoCall, deliveryCall]).then((results) => {
                    const deliveryAddress = results[0];
                    const contactInfo = results[1] ?? { data: {} };
                    const delivery = results[2];

                    let primaryAddressIndex = deliveryAddress.data.value[0].Account_CustomerAddress.findIndex(obj => obj.ed_primary === true)

                    setSelectedAddressOptions(primaryAddressIndex);
                    setDeliveryAddressOptions(deliveryAddress.data.value[0].Account_CustomerAddress)

                    isReadyToSend(contactInfo.data); // Use when userdata is retrived - combind with maintenancestatus?

                    setPromiseDate(delivery.data.promiseDate.split('T')[0]);
                    setFreight(delivery.data.freight ?? 999);

                    // Check 
                    //checkMaintenance(maintenance);

                    isValidDeliveryDate(delivery.data.requiredDate.split('T')[0], "2099-01-01");

                    setReseller({
                        ...reseller,
                        Name: deliveryAddress.data.value[0].Account_CustomerAddress[primaryAddressIndex]?.name?.trim() ?? undefined,
                        Address1: deliveryAddress.data.value[0].Account_CustomerAddress[primaryAddressIndex]?.line1?.trim() ?? undefined,
                        Address2: deliveryAddress.data.value[0].Account_CustomerAddress[primaryAddressIndex]?.line2?.trim() ?? undefined,
                        Address3: deliveryAddress.data.value[0].Account_CustomerAddress[primaryAddressIndex]?.line3?.trim() ?? undefined,
                        City: deliveryAddress.data.value[0].Account_CustomerAddress[primaryAddressIndex]?.city?.trim() ?? undefined,
                        PostalCode: deliveryAddress.data.value[0].Account_CustomerAddress[primaryAddressIndex]?.postalcode?.trim() ?? undefined,
                        Country: convertToCountry(deliveryAddress.data.value[0].Account_CustomerAddress[primaryAddressIndex]?.country),
                    });
                    setInputs({
                        ...inputs,
                        DeliveryNotificationPhone:
                            contactInfo.telephone1 ?? '',
                    });
                    setOptionalAddress({
                        ...optionalAddress,
                        Country: convertToCountry(deliveryAddress.data.value[0].Account_CustomerAddress[primaryAddressIndex]?.country)
                    });

                    setIsLoading(false);
                });
            } catch (err) {
                console.error('Failed to fetch: ', err);
                setError({ status: "ERROR", type: "fetch-data-error", message: "Failed to fetch data", details: err })
                alertLoadingError(t)
                setIsLoading(false)
            }
        };

        if (globalState?.activeUserCompany) {
            fetchData();
        }
    }, [cartItems, globalState.activeUserCompany]); // eslint-disable-line react-hooks/exhaustive-deps

    let isValidDeliveryDate = (requested, base = "2099-01-01") => {
        let baseDate = new Date(base).getTime(),
            requestedDate = new Date(requested).getTime();
        if (baseDate < requestedDate) {
            setError({ status: "ERROR", type: "atp-error", details: "One or more products cannot be delivered" })
            return;
        }

        setError({ status: "OK", type: "", details: "Success" })
    }
    /**
     * Place order
     */
    let onSubmit = (event) => {
        event.preventDefault();

        try {
            const addresses = useOptionalAddress ? optionalAddress : reseller;
            if (!onGoingMaintenance && error.type !== "atp-error") {
                placeOrder({
                    inputs,
                    cartItems,
                    CustomerId: custNumber, // this is only for frontend, correct value is set and validated in placeOrder function in order service 
                    ShipTo: custNumber, // same here
                    requestedDate: requestedDate.replace(/-/g, ''),
                    addresses: [handleAddress(addresses)],
                }, reseller);
            } else {
                confirmAlert({
                    title: t('error.title.oops'),
                    message: errorMessage,
                    buttons: [
                        {
                            label: t('button.close'),
                            className: 'button-primary',
                        },
                    ],
                })
            }
        } catch (error) {
            console.log('error', error);
        }
        return;
    };

    /*  let checkMaintenance = (maintenanceData) => {
          let currentDate = Date.now(),
              fromDate = new Date(maintenanceData.data.value[0].ed_frommaintenancedate).getTime(),
              toDate = new Date(maintenanceData.data.value[0].ed_tomaintenancedate).getTime();
          if (maintenanceData.data.value[0].statuscode === 1 && fromDate <= currentDate && currentDate <= toDate) {
              setOnGoingMaintenance(true)
          }
      } */

    /**
     * Check of cart is empty.
     */
    let checkEmptyCart = () => {
        if (cartItems.length <= 0) {
            alert('Cart is empty.'); //eslint-disable-line
        }
    };

    /**
     * Check if obj has an empty property
     * With websiteurl exception
     * @param {*} obj
     * @returns Boolean
     */
    let checkIfEmpty = (obj) => {
        let isEmpty = { status: false, key: null };
        for (var key in obj) {
            if (
                obj[key] === undefined ||
                obj[key] === null ||
                obj[key] === ''
            ) {
                isEmpty = { status: true, key };
                if (key === 'websiteurl') {
                    isEmpty = { status: false, key: null };
                } // Not important for
                if (isEmpty.status) {
                    return isEmpty;
                }
            }
        }
        return isEmpty;
    };

    /**
     *
     * Empty Cart
     * No Cust Id
     * Deliverydate
     * Checks if
     * @param {*} reseller
     * @returns
     */
    let isReadyToSend = (reseller) => { //eslint-disable-line
        let emptyFields = checkIfEmpty(reseller);
        if (cartItems.length <= 0) {
            setErrorMessage(t('error.cart-is-empty'))
            return;
        }
        if (emptyFields.status) {
            setErrorMessage(
                `${t('error.failed-to-load-user-data')} : ${emptyFields.key ?? ''}`
            );
            return;
        }

        setReadyToSend(true);
    };

    const getATP = (date) => {
        setLoadingATP(true);
        callApi({
            method: 'post',
            url: '/api/order/deliveryDate',
            data: {
                cartItems,
                requestedDate: date.replace(/-/g, ''),
            },
        }).then((res) => {
            setPromiseDate(res.data.promiseDate.split('T')[0]);
            isValidDeliveryDate(res.data.requiredDate.split('T')[0], "2099-01-01");
            setFreight(res.data.freight ?? 999);
            setLoadingATP(false);
        });
    };

    const onRequestedDateChange = (event) => {
        setRequestedDate(event.target.value);
        getATP(event.target.value);
    };

    let onChange = (event) => {
        event.persist();
        setInputs((inputs) => ({
            ...inputs,
            [event.target.name]: event.target.value,
        }));
    };

    /**
     * Update reseller data
     */
    let onChangeReseller = (event) => {
        event.persist();

        setOptionalAddress((optionalAddress) => ({
            ...optionalAddress,
            [event.target.name]: event.target.value,
        }));
    };

    let onChangeDeliveryOption = (event) => {
        event.persist();
        setSelectedAddressOptions(event.target.value);
        setReseller({
            ...reseller,
            Name:
                deliveryAddressOptions[event.target.value].name ??
                undefined,
            Address1: deliveryAddressOptions[event.target.value].line1 ?? undefined,
            Address2: deliveryAddressOptions[event.target.value].line2 ?? undefined,
            Address3: deliveryAddressOptions[event.target.value].line3 ?? undefined,
            City: deliveryAddressOptions[event.target.value].city ?? undefined,
            PostalCode:
                deliveryAddressOptions[event.target.value].postalcode ?? undefined,
            Country: convertToCountry(deliveryAddressOptions[event.target.value].country) ?? undefined,
        });
    }
    /**
     * Convert to multiple address fields if needed.
     */
    let handleAddress = (reseller) => {
        if (reseller.Address1 === undefined) {
            setErrorMessage(t('error.reseller-address-undefined'))
            return;
        }
        let addressArr = reseller.Address1.match(/.{1,74}/g);
        if (addressArr) {
            addressArr.forEach((add, index) => {
                reseller['Address' + (index + 1)] = add;
            });
        }
        return reseller;
    };

    let AddressFields = () => {
        return (
            <div>
                {(!useOptionalAddress) &&
                    <>
                        <label htmlFor="alternative-delivery-address">
                            {t('checkout.forms.alt-delivery-option')}
                        </label>
                        <div className="field-select">
                            <select
                                id="DeliveryAddressOption"
                                name="DeliveryAddressOption"
                                className="field field-select-input"
                                onChange={onChangeDeliveryOption}
                                value={selectedAddressOptions}>
                                {deliveryAddressOptions.map((addressOption, index) => (
                                    <option key={index} value={index}>{`${addressOption.name}, ${addressOption.city}`}</option>
                                ))}
                            </select>
                        </div>
                    </>
                }

                {useOptionalAddress ?
                    <AltDelivery
                        onChangeReseller={onChangeReseller}
                        onChange={onChange}
                        inputs={inputs}
                        reseller={optionalAddress}
                    />
                    :
                    <StdDelivery reseller={reseller} />
                }

                {(
                    <div className="field-item field-item-checkbox select-checkbox-container">
                        <input
                            type="checkbox"
                            id="alternative-delivery-address"
                            data-target=".alternative-delivery-address-block"
                            onChange={() => {
                                setUseOptionalAddress(!useOptionalAddress);

                                inputs.ShippingInstructions = ' ';
                            }}
                            checked={useOptionalAddress}
                        />
                        <label htmlFor="alternative-delivery-address">
                            {t('checkout.forms.alt-delivery-address')}

                        </label>
                    </div>
                )}
            </div>
        );
    };

    let DateComponent = () => {
        const today = new Date().toISOString().split('T')[0];
        return (
            <div>
                <div className="field-item">
                    <label htmlFor="RequestedShipDate">
                        {t('checkout.forms.select-delivery-date')}
                    </label>
                    <input
                        className="field field-search"
                        type="date"
                        id="RequestedShipDate"
                        name="RequestedShipDate"
                        min={today}
                        value={requestedDate}
                        onChange={onRequestedDateChange}
                    />
                </div>

                {loadingATP ? (
                    <p className="txt-loading">{t('orders.loading')}</p>
                ) : (
                    error.type === "atp-error" ? (
                        <p className="error">{t('error.title.' + error.type)}</p>

                    ) : (
                        <p>
                            {t('checkout.forms.estimated-delivery-date')}: {promiseDate}
                        </p>
                    )
                )}

            </div >
        );
    };

    let ShippingInstructions = () => {
        const cartContainsConfig = cartItems.some((item) => item.type === 'config');
        return (
            <div>
                <label className="label" htmlFor="GoodsMark">
                    {t('checkout.forms.invoice-label')}
                </label>
                <input
                    className="field field-text"
                    name="GoodsMark"
                    id="GoodsMark"
                    type="text"
                    maxLength="75"
                    onChange={onChange}
                />
                <div className="">
                    <label className="label" htmlFor="ShippingInstructions">
                        {t('checkout.forms.delivery')}
                    </label>
                    <div className="field-select">
                        <select
                            id="ShippingInstructions"
                            name="ShippingInstructions"
                            className="field field-select-input"
                            onChange={onChange}
                            required
                            {...((cartContainsConfig || useOptionalAddress) && { readOnly: 'readonly' })}
                            value={inputs.ShippingInstructions}>
                            <option value=" ">{t('checkout.forms.standard-delivery')}</option>
                            {!cartContainsConfig && !useOptionalAddress && (
                                <option value="SAMLEV">{t('checkout.forms.co-delivery')}</option>
                            )}
                        </select>
                    </div>
                </div>
                {cartItems.length > 0 && <DateComponent />}
            </div>
        );
    };

    return (
        <div className="checkout">
            <h1>{t('checkout.forms.checkout')}</h1>
            {isLoading &&
                <div>
                    <LargeFormLoader />
                </div>
            }
            {!isLoading &&
                <form method="POST" onSubmit={onSubmit}>
                    {AddressFields()}
                    {ShippingInstructions()}

                    <div className="row order-checkout-footer">
                        <p
                            className="button button--go-back"
                            onClick={() => {
                                history.push('/order-add');
                            }}>
                            {t('checkout.forms.continue')}
                        </p>

                        <button
                            type="submit"
                            className={`button-submit button-secondary${loadingATP ? ' btn-loading' : ''}`}
                            disabled={loadingATP || error.type === "atp-error" || error.type === "fetch-data-error"}
                        >
                            <span>{t('checkout.forms.send')}</span>
                        </button>
                    </div>
                    <p className='cart-summary-label'>{t('checkout.forms.delivery-message')}</p>
                </form>
            }
            {onGoingMaintenance && <h3 className='content-primary'>{t('orders.maintenance-text')}</h3>}
        </div >
    );
}
